export const ROUTE_PATH = '/reconciliation-promotions';

export const FEATURE_NAME = 'reconciliationPromotionsPage';
